<template>
  <div class="header-box">
    <div class="header-top">
      <div class="top-left">
        <img src="./image/logo_text.png" />
        {{ $t("index.title") }}
      </div>
      <div class="top-right">
        <div v-if="showLogin">
          <el-button round class="btn-login" @click="gologin">{{
            $t("login.title")
          }}</el-button>
          <el-button round class="btn-register" @click="gotoRegister">{{
            $t("header.zc")
          }}</el-button>
        </div>
        <div v-else class="top-right-logout">
          <span class="entName-text" v-if="entState == '0'">
            {{ entName }}
          </span>
          <el-divider direction="vertical" v-if="entState == '0'"></el-divider>
          <el-menu
            :default-active="settingActive"
            class="menu-setting"
            mode="horizontal"
            router
            @select="settingHandleSelect"
          >
            <el-submenu index="1" class="menu-setting-sub">
              <template slot="title">
                <span v-if="entState == '0'">{{ userName }}</span>
                <span v-if="entState == '1'"> {{ userName }}</span>
                ,{{ $t("index.hello") }}
              </template>
              <!--sjb2为时是物流司机账号，不显示个人设置-->
              <el-submenu
                index="/settings"
                popper-append-to-body
                v-if="sjBs != '2'"
              >
                <template slot="title">{{ $t("index.grsz") }}</template>
                <!--动态展示个人设置子菜单-->
                <el-menu-item
                  v-for="item in mySettings.children"
                  :key="item.orderIndex"
                  :index="item.path"
                  popper-append-to-body
                >
                  {{ item.title }}
                </el-menu-item>
                <el-menu-item @click="gologout1">{{
                  $t("wtlh.zhuxiao")
                }}</el-menu-item>
                <!--个人设置 静态子菜单-->
                <!--                <el-menu-item index="/settings/userInfomaintenance">{{ $t('register.yhxx') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/receiptInfo">{{ $t('containerPreOrder.shxx') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/shipmentInfo">{{ $t('containerPreOrder.fhxx') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/bindManage">{{ $t('settings.jbrgl') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/changeUser">{{ $t('settings.yhqh') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/binding">{{ $t('settings.khgx') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/crmAdd">{{ $t('settings.sqdl') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/crmAuth">{{ $t('settings.shlb') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/changeMessage">{{ $t('settings.mmxg') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/changePhone">{{ $t('settings.sjhgh') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/signature">{{ $t('settings.qyqz') }}</el-menu-item>-->
                <!--                <el-menu-item index="/settings/driverManagement">{{ $t('settings.jqsdsjgl') }}</el-menu-item>-->
              </el-submenu>
              <el-menu-item @click="gologout">{{
                $t("index.tcdl")
              }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <el-divider direction="vertical"></el-divider>
          <el-badge :value="msgTotal || 0" class="item">
            <span
              class="message-icon el-icon-message-solid"
              @click="gotoMyMessage"
            ></span>
          </el-badge>
        </div>
      </div>
      <div class="lang-select">
        <span>{{ $t("index.yyxz") }}</span>
        <lang-select :state="'1'"></lang-select>
      </div>
    </div>
    <!--账号为非物流公司-->
    <div class="header-menu" v-if="sjBs != '2'">
      <div class="header-left">
        <el-menu
          mode="horizontal"
          :default-active="menuActive"
          @select="handleMenuSelect"
          class="el-menu-demo"
          :router="true"
        >
          <el-menu-item index="/">{{ $t("index.sy") }}</el-menu-item>
          <el-submenu index="2">
            <template slot="title">{{ $t("index.fsyw") }}</template>
            <el-menu-item-group
              :title="$t('index.gjly')"
              class="menu-classify-left"
            >
              <template slot="title">
                <img src="./image/guojilianyun.png" :alt="$t('index.gjly')" />
                {{ $t("index.gjly") }}
              </template>
              <el-menu-item
                index="/shipmentBusiness/intlPeriodApply"
                @click="redirectToTransport('intlPeriodApply', '0')"
              >
                {{ $t("index.yxqtb") }}
              </el-menu-item>
              <el-menu-item
                index="/shipmentBusiness/emptyVanBook"
                @click="redirectToTransport('emptyVanBook', '0')"
              >
                {{ $t("index.tlxyd") }}
              </el-menu-item>
              <el-menu-item index="/shipmentBusiness/zlydApply">
                {{ $t("index.glydtb") }}
              </el-menu-item>
              <el-menu-item
                index="/shipmentBusiness/dayDemandApply"
                @click="redirectToTransport('dayDemandApply', '0')"
              >
                {{ $t("index.rxqtb") }}
              </el-menu-item>
              <el-menu-item
                index="/shipmentBusiness/waybillFill"
                @click="redirectToTransport('waybillFill', '0')"
              >
                {{ $t("index.zbxfh") }}
              </el-menu-item>
              <!-- <el-menu-item index="/shipmentBusiness/oneClickDelivery">
                {{ $t("oneClickDelivery.yjfh") }}
              </el-menu-item> -->
            </el-menu-item-group>
            <el-menu-item-group
              :title="$t('index.gnys')"
              class="menu-classify-left"
            >
              <template slot="title">
                <img src="./image/guoneiyunshu.png" :alt="$t('index.gnys')" />
                {{ $t("index.gnys") }}
              </template>
              <el-menu-item
                index="/shipmentBusiness/intlPeriodApply"
                @click="redirectToTransport('intlPeriodApply', '1')"
              >
                {{ $t("index.yxqtb") }}
              </el-menu-item>
              <el-menu-item
                index="/shipmentBusiness/emptyVanBook"
                @click="redirectToTransport('emptyVanBook', '1')"
              >
                {{ $t("index.tlxyd") }}
              </el-menu-item>
              <el-menu-item index="/shipmentBusiness/containerLoading">
                {{ $t("index.zx") }}
              </el-menu-item>
              <el-menu-item
                index="/shipmentBusiness/dayDemandApply"
                @click="redirectToTransport('dayDemandApply', '1')"
              >
                {{ $t("index.rxqtb") }}
              </el-menu-item>
              <el-menu-item
                index="/shipmentBusiness/waybillFill"
                @click="redirectToTransport('waybillFill', '1')"
              >
                {{ $t("index.zbxfh") }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="/transportService">
            <template slot="title">{{ $t("index.hyfw") }}</template>
            <el-submenu index="/track">
              <template slot="title">{{ $t("index.hwzz") }}</template>
              <el-menu-item index="/transportService/track/trackGlyd">{{
                $t("index.glhwzz")
              }}</el-menu-item>
              <el-menu-item index="/transportService/track/trackGnys">{{
                $t("index.gnhwzz")
              }}</el-menu-item>
            </el-submenu>
            <el-menu-item index="/transportService/trackGoods">{{
              $t("index.ddyc")
            }}</el-menu-item>
            <el-menu-item index="/transportService/loadingTruck">{{
              $t("index.zxcxx")
            }}</el-menu-item>
            <el-menu-item index="/transportService/freightInquiry">{{
              $t("index.yfcx")
            }}</el-menu-item>
            <el-menu-item index="/transportService/cargoClaims">{{
              $t("jqsd.hscl")
            }}</el-menu-item>
          </el-submenu>
          <el-submenu index="/deliveryBusiness">
            <template slot="title">{{ $t("index.ddyw") }}</template>
            <!-- <el-menu-item index="/deliveryBusiness/appointPickupGoods">{{ $t('index.yylx') }}</el-menu-item>
            <el-menu-item index="/deliveryBusiness/appointReturnContainer">{{ $t('index.yyhx') }}</el-menu-item> -->
            <!-- <el-menu-item index="/deliveryBusiness/zwhx">{{ $t('index.zwhx') }}</el-menu-item> -->
            <el-menu-item index="/deliveryBusiness/lxtz">{{
              $t("oneClickDelivery.lxtz")
            }}</el-menu-item>
            <el-menu-item index="/deliveryBusiness/jzyy">{{
              $t("oneClickDelivery.jzyy")
            }}</el-menu-item>
          </el-submenu>
          <el-submenu index="/guide">
            <template slot="title">{{ $t("index.blzn") }}</template>
            <el-menu-item index="/guide/processMap">{{
              $t("processMap.crumbs1")
            }}</el-menu-item>
            <el-menu-item index="/guide/stationBasicInfo">{{
              $t("processMap.czjbxx")
            }}</el-menu-item>
            <el-menu-item index="/guide/trainInfo">{{
              $t("processMap.crumbs2")
            }}</el-menu-item>
            <el-menu-item index="/guide/containerInfo">{{
              $t("processMap.jzxxx")
            }}</el-menu-item>
            <el-submenu index="/guide/price">
              <template slot="title">{{ $t("processMap.yjfl") }}</template>
              <el-menu-item index="/guide/price/freight">{{
                $t("processMap.yunf")
              }}</el-menu-item>
              <el-menu-item index="/guide/price/incidentalsInfo">{{
                $t("processMap.zaf")
              }}</el-menu-item>
            </el-submenu>
            <el-menu-item index="/guide/legalFile">{{
              $t("processMap.flfgjxgwj")
            }}</el-menu-item>
            <el-submenu index="/guide/insurance">
              <template slot="title">{{ $t("index.baox") }}</template>
              <el-menu-item index="/guide/insurance/insuranceNotice">{{
                $t("processMap.tbxz")
              }}</el-menu-item>
              <el-menu-item index="/guide/insurance/insuranceTerms">{{
                $t("processMap.bxtk")
              }}</el-menu-item>
            </el-submenu>
            <el-menu-item index="/guide/handleFAQ">{{
              $t("processMap.hyblwt")
            }}</el-menu-item>
          </el-submenu>
          <el-submenu index="/contact">
            <template slot="title">{{ $t("index.lxwm") }}</template>
            <!--            <el-menu-item index="2-1">公司介绍</el-menu-item>-->
            <el-menu-item index="/contact/complaints">{{
              $t("index.tsjy")
            }}</el-menu-item>
          </el-submenu>
          <el-submenu index="/orders" v-if="!showLogin">
            <template slot="title">{{ $t("index.myOrders") }}</template>
            <el-menu-item-group
              :title="$t('index.ddzx')"
              class="menu-classify-left"
            >
              <template slot="title">
                <img src="./image/myOrders.png" :alt="$t('index.ddzx')" />
                {{ $t("index.ddzx") }}
              </template>

              <!--动态展示 我的订单 子菜单-->
              <el-menu-item
                v-for="item in myOrders.children"
                :key="item.orderIndex"
                :index="item.path"
                popper-append-to-body
              >
                {{ item.title }}
              </el-menu-item>

              <!--我的订单 静态子菜单-->
              <!--<el-menu-item index="/orders/phaseTransportDemand">
                {{ $t('index.yxqlb') }}
              </el-menu-item>
              <el-menu-item index="/orders/containerPreOrderQry">
                {{ $t('index.ydxlb') }}
              </el-menu-item>
              <el-menu-item index="/orders/dailyTransportDemand">
                {{ $t('index.rxqlb') }}
              </el-menu-item> -->
              <!--              <el-menu-item  index="">-->
              <!--                装箱列表-->
              <!--              </el-menu-item>-->
              <!--<el-menu-item index="/orders/leagueOfNationsWaybill/leagueOfNationsWaybill">
                {{ $t('index.glydlb') }}
              </el-menu-item>
              <el-menu-item index="/orders/containerDelete">
                {{ $t('index.ydzf') }}
              </el-menu-item>
              <el-menu-item index="/orders/transportStatistics">
                {{ $t('index.hytj') }}
              </el-menu-item>
              <el-menu-item index="/orders/jqsdOrderManager">
                {{ $t('index.jqsddcx') }}
              </el-menu-item>
              <el-menu-item index="/orders/jqsdOrderSign">
                {{ $t('index.jqsddcqr') }}
              </el-menu-item>-->
            </el-menu-item-group>

            <!--            <el-menu-item-group title="待办事项" class="menu-classify-left">-->
            <!--              <template slot="title">-->
            <!--                <img src="../../image/server-hot.png" alt="图片描述" />-->
            <!--                待办事项-->
            <!--              </template>-->
            <!--              <el-menu-item  index="">-->
            <!--                待签认-->
            <!--              </el-menu-item>-->
            <!--              <el-menu-item  index="">-->
            <!--                待领空箱-->
            <!--              </el-menu-item>-->
            <!--              <el-menu-item  index="">-->
            <!--                待货物进站-->
            <!--              </el-menu-item>-->
            <!--              <el-menu-item  index="">-->
            <!--                待领货-->
            <!--              </el-menu-item>-->
            <!--              <el-menu-item  index="">-->
            <!--                待还箱-->
            <!--              </el-menu-item>-->
            <!--            </el-menu-item-group>-->

            <el-menu-item-group
              :title="$t('index.wdpj')"
              class="menu-classify-left"
            >
              <template slot="title">
                <img src="./image/yufukuanicon.png" :alt="$t('index.wdpj')" />
                {{ $t("index.wdpj") }}
              </template>
              <el-menu-item index="/orders/preDepositDetailCustomer">
                {{ $t("index.yfkjymx") }}
              </el-menu-item>
              <el-menu-item index="/orders/confirmationBill">
                {{ $t("index.pjqr") }}
              </el-menu-item>
              <!--              <el-menu-item  index="">-->
              <!--                预付款提取-->
              <!--              </el-menu-item>-->
              <!--              <el-menu-item  index="">-->
              <!--                凭证管理-->
              <!--              </el-menu-item>-->
              <!--              <el-menu-item  index="">-->
              <!--                代付申请-->
              <!--              </el-menu-item>-->
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </div>
      <div class="header-right"></div>
    </div>

    <!--账号为物流公司-->
    <div class="header-menu" v-if="sjBs == '2'">
      <div class="header-left">
        <el-menu
          mode="horizontal"
          :default-active="menuActive"
          @select="handleMenuSelect"
          class="el-menu-demo"
          :router="true"
        >
          <el-menu-item index="/">{{ $t("index.sy") }}</el-menu-item>
          <el-menu-item index="/orders/jqsdOrderManager">
            {{ $t("index_page.jqsd") }}
          </el-menu-item>
          <el-menu-item index="/settings/driverManagement">{{
            $t("settings.jqsdsjgl")
          }}</el-menu-item>
          <el-menu-item index="/settings/kchwh">{{
            $t("settings.kchwh")
          }}</el-menu-item>
        </el-menu>
      </div>
      <div class="header-right"></div>
    </div>
    <el-dialog :visible.sync="visible" :title="$t('index.tis')" width="400px" top="20%">
      <!-- 注销会删除当前企业用户，且无法登录，是否确认？ -->
    <div style="color: red; text-align: center; margin-top: 30px;">{{$t('wtlh.zcqrzxdqzh')}}</div>
    <span slot="footer">
      <el-button @click="visible = false">{{$t('index.qx')}}</el-button>
      <el-button type="primary" :disabled="countdown > 0" @click="handleConfirm">
        {{ confirmText }}
      </el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import menuData from "@/menu/modules/menu";
import { queryMsgTotalApi } from "@/api/message/message";
import { userzx } from "@/api/settings/userInfo";
import LangSelect from "@/components/langSelect/index.vue";

export default {
  name: "header-aside-menu-header",
  components: {
    LangSelect
  },
  computed: {
  ...mapState("d2admin/user", ["info"]),
  confirmText() {
    return this.countdown > 0 
      ? `${this.$t('index.qd')} (${this.countdown}s)` 
      : this.$t("index.qd");
  }
},
  data() {
    return {
      visible:false,
      countdown: 5,
      searchKey: "",
      menuActive: "/",
      isScroll: false,
      scrollWidth: 0,
      contentWidth: 0,
      currentTranslateX: 0,
      throttledCheckScroll: null,
      showLogin: true,
      settingActive: "",
      msgTotal: "",
      userName: "",
      entName: "",
      entState: "0",
      mySettings: {},
      myOrders: {},
      sjBs: ""
    };
  },
  methods: {
    redirectToTransport(name, periodType) {
      localStorage.setItem("periodType", periodType);
      // 跳转到指定路由，并传递type参数
      this.$router.push({
        name: name,
        query: { periodType: periodType }
      });
    },
    settingHandleSelect() {},
    async getMsgTotal(val) {
      let ret = await queryMsgTotalApi(val);
      if (ret.code == 200) {
        this.msgTotal = ret.data > 99 ? "99+" : ret.data + "";
      }
    },
    handleMenuSelect(index, indexPath) {
      if (/^menu-empty-\d+$/.test(index) || index === undefined) {
        this.$message.warning("临时菜单");
      } else {
        if (index == "/transport") {
          this.$router.push({
            path: "/transport/workbench"
          });
        } else {
          this.menuActive = index;
          this.$router.push({
            path: index
          });
        }
      }
    },
    gologout1() {
      this.$confirm(
        window.vm.$i18n.t("wtlh.qdzxdqzhm"),
        window.vm.$i18n.t("index.tis"),
        {
          confirmButtonText: window.vm.$i18n.t("index.qd"),
          cancelButtonText: window.vm.$i18n.t("index.qx"),
          center: true
        }
      )
        .then(() => {
          this.visible = true;
          this.countdown = 5;
          const timer = setInterval(() => {
            if (this.countdown > 0) {
              this.countdown--;
            } else {
              clearInterval(timer);
            }
          }, 1000);
          
        })
        .catch(() => {
          // this.$message('放弃注销用户')
        });
    },
    handleConfirm() {
      let userName = window.sessionStorage.getItem("userId");
          // console.log(userName)
          // return
          userzx({
            userName: userName
          })
            .then(res => {
              // console.log(res)
              if (res.data) {
                this.visible = false;
                // 增加退出刷新页面，用户物流公司用户退出后刷新页面更新头部菜单
                window.location.reload();
                // this.$axios.post('UserLogout.do',{}).then(data=>{
                menuData.List.length = 4;
                const titleMap = {
                  "/": "index.sy",
                  "/transport": "index.ysfw",
                  "/commerce": "index.smjy",
                  "/complaintsSuggestions": "index.tsyjy"
                };

                menuData.List.forEach(item => {
                  item.title = window.vm.$i18n.t(titleMap[item.path]);
                });
                this.$store.commit("d2admin/menu/headerSet", menuData.List);
                window.sessionStorage.removeItem("userId");
                window.sessionStorage.removeItem("ent");
                window.sessionStorage.removeItem("entId");
                window.sessionStorage.removeItem("entState");
                window.sessionStorage.removeItem("initMenu");
                window.sessionStorage.removeItem("token");
                window.sessionStorage.removeItem("rights");
                window.sessionStorage.removeItem("sjBs");
                window.sessionStorage.removeItem("changeLangData");
                this.showLogin = true;
                if (this.$route.path == "/") {
                  this.goto({
                    path: "refresh",
                    name: "refresh"
                  });
                } else {
                  this.goto({
                    path: "index",
                    name: "index"
                  });
                }
                //   }).catch(error=>{
                //   })
              }
            })
            .catch(() => {});
      
    },
    gologout() {
      this.$confirm(
        window.vm.$i18n.t("index.qrtczh"),
        window.vm.$i18n.t("index.tis"),
        {
          confirmButtonText: window.vm.$i18n.t("index.qd"),
          cancelButtonText: window.vm.$i18n.t("index.qx"),
          center: true
        }
      )
        .then(() => {
          // 增加退出刷新页面，用户物流公司用户退出后刷新页面更新头部菜单
          window.location.reload();
          // this.$axios.post('UserLogout.do',{}).then(data=>{
          menuData.List.length = 4;
          const titleMap = {
            "/": "index.sy",
            "/transport": "index.ysfw",
            "/commerce": "index.smjy",
            "/complaintsSuggestions": "index.tsyjy"
          };

          menuData.List.forEach(item => {
            item.title = window.vm.$i18n.t(titleMap[item.path]);
          });
          this.$store.commit("d2admin/menu/headerSet", menuData.List);
          window.sessionStorage.removeItem("userId");
          window.sessionStorage.removeItem("ent");
          window.sessionStorage.removeItem("entId");
          window.sessionStorage.removeItem("entState");
          window.sessionStorage.removeItem("initMenu");
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("rights");
          window.sessionStorage.removeItem("sjBs");
          window.sessionStorage.removeItem("changeLangData");
          this.showLogin = true;
          if (this.$route.path == "/") {
            this.goto({
              path: "refresh",
              name: "refresh"
            });
          } else {
            this.goto({
              path: "index",
              name: "index"
            });
          }
          //   }).catch(error=>{
          //   })
        })
        .catch(() => {
          // this.$message('放弃注销用户')
        });
    },
    openDocument() {
      window.open(this.DOCUMENTURL);
    },
    openBuiltInSystem() {
      // window.location.href ='http://www.hjtlgs.com/mgt/index.html#/login';
      window.open(this.InSystem_Url);
    },
    openDecision() {
      window.open(this.DecisionSystem_Url);
    },
    gologin() {
      this.goto("/login");
    },
    gotoRegister() {
      this.goto("/register");
      // this.goto('/register/enterInfo')
    },
    gotoSettings() {
      this.goto("/settings");
    },
    gotoMyMessage() {
      this.goto("/myMessage");
    },
    tabHandleClick(tab, event) {
      console.log(tab, event);
    }
  },
  created() {
    this.userName = window.sessionStorage.getItem("userName");
    this.entName = window.sessionStorage.getItem("ent");
    this.entState = window.sessionStorage.getItem("entState");
    this.mySettings = JSON.parse(
      window.sessionStorage.getItem("initMenu")
    ).find(item => item.path === "/settings");
    console.log(this.mySettings);
    if (
      this.mySettings.children &&
      Array.isArray(this.mySettings.children) &&
      this.mySettings.children.length > 0
    ) {
      this.mySettings.children = this.mySettings.children.filter(item => {
        return (
          item.value != "binding" &&
          item.value != "crmAdd" &&
          item.value != "crmAuth"
        );
      });
    }

    this.myOrders = JSON.parse(window.sessionStorage.getItem("initMenu")).find(
      item => item.path === "/orders"
    );
    this.sjBs = window.sessionStorage.getItem("sjBs");
    console.log("this.myOrders", this.myOrders);
    this.myOrders = {
      ...this.myOrders,
      children: this.myOrders.children.filter(item => {
        const isUnwanted =
          item.title === "月运输详情" ||
          item.title === "日运输详情" ||
          item.title === "国联运单编辑";
        return !isUnwanted;
      })
    };
  },
  mounted() {
    if (window.sessionStorage.getItem("userId") != null) {
      this.showLogin = false;
    } else {
      this.showLogin = true;
    }
    let lang = localStorage.getItem("lang");
    this.$i18n.locale = lang;
    this.$store.dispatch("app/setLanguage", lang);
    if (!this.showLogin) {
      this.getMsgTotal("0");
    }

    this.$eventBus.$on("msgTotal", () => {
      this.getMsgTotal("0");
    });
  }
};
</script>

<style lang="scss">
.header-box {
  max-width: 1920px;
  margin: 0 auto;
  background-color: $main-background;
  position: relative;

  .header-top {
    margin: 0 auto;
    width: $containerWidth;
    height: 79px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .lang-select {
      position: absolute;
      top: 15px;
      right: 30px;

      span {
        font-size: 14px;
        padding: 0 5px;
        margin-right: 3px;
        border-right: 2px solid #a0a0a0;
      }
    }

    .top-left {
      width: fit-content;
      min-width: 300px;
      height: 42px;
      display: flex;
      font-size: 28px;

      img {
        width: 130px;
        height: 42px;
      }
    }

    .top-right {
      min-width: 215px;
      height: 38px;
      margin-top: 20px;
      //display: flex;
      //flex-direction: column;
      //align-items: flex-end;
      .el-button {
        min-width: 100px;
        height: 38px;
        border-radius: 23.5px;
        font-size: 14px;
        letter-spacing: 0;
        text-align: center;
        line-height: 14px;
        font-weight: 500;
      }

      .btn-login {
        color: #ffffff;
        background-image: linear-gradient(180deg, #02C362 0%, #63D788 100%);
      }

      .btn-register {
        color: #39313c;
        box-sizing: border-box;
        border: 1px solid rgba(54, 45, 57, 1);
      }

      .top-right-logout {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 15px 0;

        .entName-text {
          font-size: 14px;
          color: #333333;
          font-weight: 400;
        }

        .message-icon {
          display: inline-block;
          margin-right: 10px;
          font-size: 22px;
          position: relative;
          cursor: pointer;
          transition: color 0.2s ease;

          .message-total {
            text-align: center;
            position: absolute;
            top: 0;
            right: -2px;
            font-size: 14px;
            font-style: normal;
            color: #fff;
            font-weight: 400;
            background: #ce1225;
            border-radius: 100%;
            width: 5px;
            height: 5px;
          }
        }

        .el-badge__content {
          color: #02C362;
          border-color: #7cdbab;
          background-color: rgb(209, 247, 228);
        }

        .message-icon:hover {
          color: #02C362;
        }

        .menu-setting {
          width: fit-content;

          .menu-setting-sub {
            .el-submenu__title {
              padding: 0;
              height: 40px;
              line-height: 40px;
              color: #02C362;
              border-bottom-color: #02C362;

              > span {
                vertical-align: unset;
              }

              .el-submenu__icon-arrow {
                color: #02C362;
              }
            }
          }
        }
      }
    }
  }

  .header-menu {
    //padding: 0 50px 0 360px;
    display: flex;
    justify-content: center;
    align-items: center;

    .header-left {
      min-width: $containerWidth;

      .el-menu {
        background: #ffffff;

        .el-menu-item,
        .el-submenu {
          width: fit-content;
          min-width: 140px;
          text-align: center;
        }

        .el-menu-item,
        .el-submenu__title {
          color: #222222 !important;
          font-size: 18px;
        }

        .el-menu-item:hover,
        .el-menu-item.is-active,
        .el-submenu__title:hover,
        .el-submenu.is-active .el-submenu__title {
          background-image: linear-gradient(180deg, #02C362 0%, #63D788 100%);
          color: #ffffff !important;
          border: none;
        }

        .el-submenu__title {
          .el-icon-arrow-down:before {
            content: "";
          }
        }
      }
    }

    .header-right {
      width: fit-content;
      display: flex;
      justify-content: space-between;
      color: #222222;

      .tools {
        display: flex;
        flex-direction: column;
        margin-right: 10px;
      }
    }
  }
}

.el-menu--horizontal {
  .el-menu--popup {
    width: auto;
    padding: 10px 20px 10px 20px;

    .menu-classify-left {
      min-width: 200px;
      float: left;
      margin-right: 10px;

      .el-menu-item-group__title {
        padding-left: 5px !important;
        font-size: 14px;
        color: #222222;
        letter-spacing: 0;
        font-weight: 600;
        display: flex;
        justify-content: flex-start;
        line-height: 22px;

        img {
          width: 22px;
          height: 22px;
          margin-right: 5px;
          vertical-align: middle;
        }
      }
    }

    .el-menu-item,
    .el-submenu {
      background: #f7f8fb !important;
      border: 0.5px solid rgba(204, 204, 204, 0.2);
      border-radius: 2px;
      margin-bottom: 10px;
      //position: relative;
      .el-submenu__title {
        background: #f7f8fb;
      }
    }

    //.el-menu-item::after {
    //  content: '>';
    //  position: absolute;
    //  top: 50%;
    //  right: 10px;
    //  transform: translateY(-50%);
    //  font-size: 18px;
    //  color: #B2B2B2;
    //}
  }
}
</style>
